import { all, takeEvery } from 'redux-saga/effects'

import { SeoActions } from '../actions'
import { change } from './change'
import { enableMode } from './enableMode'
import { init } from './init'
import { show } from './show'
import { syncFromUrl } from './syncFromUrl'

export function* seoSaga() {
  yield all([
    takeEvery(SeoActions.init, init),
    takeEvery(SeoActions.change, change),
    takeEvery(SeoActions.enableMode, enableMode),
    takeEvery(SeoActions.show, show),
    takeEvery(SeoActions.syncFromUrl, syncFromUrl),
  ])
}
